var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAuthorise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.188 4a5.13 5.13 0 015.125 5.125 5.12 5.12 0 01-2.283 4.26c2.529 1.055 4.345 3.448 4.345 6.157V20a1 1 0 01-1 1H1a1 1 0 01-1-1v-.458c0-2.709 1.817-5.102 4.346-6.157a5.12 5.12 0 01-2.283-4.26A5.13 5.13 0 017.188 4zm0 10.813c-2.611 0-4.847 1.867-5.152 4.187H12.34c-.305-2.32-2.541-4.187-5.152-4.187zM17.5 4a4.442 4.442 0 014.437 4.438 4.424 4.424 0 01-1.85 3.589c2.28.958 3.913 3.119 3.913 5.565V18a1 1 0 01-1 1h-6.875a1 1 0 010-2h5.826c-.327-1.95-2.232-3.5-4.45-3.5-1.044 0-2.029.33-2.849.955a1 1 0 11-1.212-1.591 6.6 6.6 0 011.484-.828 4.423 4.423 0 01-1.86-3.598A4.442 4.442 0 0117.5 4zM7.188 6a3.129 3.129 0 00-3.125 3.125 3.129 3.129 0 003.125 3.125 3.129 3.129 0 003.125-3.125A3.129 3.129 0 007.188 6zM17.5 6a2.44 2.44 0 00-2.438 2.438 2.44 2.44 0 002.438 2.437 2.44 2.44 0 002.438-2.437A2.44 2.44 0 0017.5 6z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconAuthorise;